import axios from 'axios';
import { BASE_URL } from './urls';

// const token =
//   typeof window !== 'undefined' ? localStorage.getItem('accessToken') : '';

const axiosConfig = {
  baseURL: BASE_URL,
  // baseURL: process.env.API_BASE_URL,
  // headers: { Authorization: token },
};

export default axios.create(axiosConfig);
